import React from 'react';

const FAQ = () => {
  return <h1> TFAQ</h1>;
};

export default FAQ;
